import { selectIsChatsEnabled } from '../offerChat';

// TODO: Удалить селектор в CD-235461. Оставлен для читаемости.
export const selectMessageButtonAvailable = selectIsChatsEnabled;
